import React, { useContext, useEffect, useState } from 'react';
import ModalDeleteAccount from '../../components/modals/modalsAccounts/deleteAccount';
import ModalCreateAccount from '../../components/modals/modalsAccounts/createAccount';
import { GET_PARTNER_CLIENT_ACCOUNTS } from '../../actions/get';
import { useLazyQuery, useMutation } from '@apollo/client';
import { AuthContext } from '../../context/auth';
import {
  saveNavigateBackFrom,
  setFilterParamsToSearchParams,
  setSortParamsToSearchParams,
} from '@/utils';
import { Box } from '@/elements';
import { useSearchParams } from 'react-router-dom';
import {
  instructionTypeForFilter,
  setSearchParamsToState,
  getQueryParamsFromSearchParams,
  queryParamsInitial,
  getVariables,
  actorTypeForAuth,
} from './Account/store';
import { AccountHeader, AccountTable } from './Account/components';
import { LOGIN_BY_EMPLOYEE } from '@/common/actions/update';

const Accounts = () => {
  const { user } = useContext(AuthContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState(() =>
    getQueryParamsFromSearchParams(searchParams, queryParamsInitial)
  );

  const [isCreated, setIsCreated] = useState(false);
  const [isDeleted, setIsDeleted] = useState({
    deleted: false,
    id: '',
    name: '',
  });
  const [loginByEmployee] = useMutation(LOGIN_BY_EMPLOYEE);

  const loginByEmployeeHandler = (email) => {
    loginByEmployee({
      variables: {
        type: actorTypeForAuth,
        email: email,
      },
    }).then((r) => {
      const win = window.open(
        `${r.data.loginByEmployee.returnUrl}?tokenByEmployee=${r.data.loginByEmployee.accessToken}`,
        '_blank'
      );
      win.focus();
    });
  };

  const [getFilter, { data, loading }] = useLazyQuery(GET_PARTNER_CLIENT_ACCOUNTS);

  useEffect(() => {
    setSearchParamsToState(searchParams, setQueryParams, queryParamsInitial);
    saveNavigateBackFrom({
      pathname: '/accounts',
      search: searchParams.toString() ? `?${searchParams.toString()}` : '',
    });
  }, [searchParams]);

  useEffect(() => {
    getPartnerClientsAccounts();
  }, [queryParams]);

  const getPartnerClientsAccounts = () =>
    getFilter({ variables: getVariables(queryParams, instructionTypeForFilter) });

  const onPageChange = (page, size) => {
    searchParams.set('page', String(page));
    searchParams.set('limit', String(size));

    setSearchParams(searchParams, { replace: true });
  };

  const onSortingChange = (sortArray) => {
    searchParams.set('page', String(queryParamsInitial.page));

    setSortParamsToSearchParams(sortArray, searchParams);

    setSearchParams(searchParams, { replace: true });
  };

  const onFiltersChange = (filterList) => {
    searchParams.set('page', String(queryParamsInitial.page));

    setFilterParamsToSearchParams(filterList, searchParams);

    setSearchParams(searchParams, { replace: true });
  };

  return (
    <Box padding="45px" gap="25px" direction="column">
      {isCreated && (
        <ModalCreateAccount
          show={isCreated}
          hideModal={() => setIsCreated(false)}
          query={GET_PARTNER_CLIENT_ACCOUNTS}
          getVariables={() => getVariables(queryParams, instructionTypeForFilter)}
          partnerAccountId={user && user.partnerAccountId}
        />
      )}

      {isDeleted.deleted && (
        <ModalDeleteAccount
          hideModal={() => setIsDeleted(!isDeleted.deleted)}
          id={isDeleted.id}
          name={isDeleted.name}
          query={GET_PARTNER_CLIENT_ACCOUNTS}
          getVariables={() => getVariables(queryParams, instructionTypeForFilter)}
        />
      )}

      <Box direction="column" gap="15px">
        <AccountHeader
          setSearchParams={setSearchParams}
          searchParams={searchParams}
          setIsCreateModalShow={() => setIsCreated(true)}
        />

        <AccountTable
          data={data?.partnerClientAccounts?.items || []}
          loading={loading}
          totalPages={data?.partnerClientAccounts?.info?.totalPages || 1}
          totalCount={data?.partnerClientAccounts?.info?.totalCount || 0}
          onPageChange={onPageChange}
          onSortingChange={onSortingChange}
          onFiltersChange={onFiltersChange}
          queryParams={queryParams}
          setIsDeleted={setIsDeleted}
          loginByEmployeeHandler={loginByEmployeeHandler}
        />
      </Box>
    </Box>
  );
};

export default Accounts;
